import * as React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent as MuiDialogContent,
  createStyles,
  withStyles,
  DialogTitle,
  IconButton,
} from '@material-ui/core';
import { MuiWidth } from 'types/common';
import CloseIcon from '@material-ui/icons/Close';
import styled from 'styled-components';

interface Props {
  open: boolean;
  onClose: () => void;
  description?: string | React.ReactNode;
  maxWidth?: MuiWidth;
  onConfirm: () => void;
  labelConfirm?: string;
  labelCancel?: string;
  title?: string;
  disableBackdropClick?: boolean;
}

const DialogContent = withStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
  }),
)(MuiDialogContent);

const ConfirmModal = ({
  open,
  onClose,
  description,
  maxWidth = 'xs',
  onConfirm,
  labelConfirm = 'Confirm',
  labelCancel = 'Cancel',
  title,
  disableBackdropClick = false, // 나중에 추가되었기에 이전 구현된 기능에 맞춰서 false를 default로 선언
}: Props) => {
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={maxWidth}
      onClose={onClose}
      disableBackdropClick={disableBackdropClick}
    >
      {title && (
        <DialogTitle>
          {title}
          <CloseButtonSpacing>
            <IconButton size={'small'} onClick={onClose}>
              <CloseIcon fontSize={'small'} />
            </IconButton>
          </CloseButtonSpacing>
        </DialogTitle>
      )}
      <DialogContent dividers>{description}</DialogContent>
      <DialogActions>
        {labelCancel && (
          <Button variant={'text'} color={'secondary'} onClick={onClose}>
            {labelCancel}
          </Button>
        )}
        {labelConfirm && (
          <Button variant={'text'} color={'primary'} onClick={onConfirm}>
            {labelConfirm}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

const CloseButtonSpacing = styled.div`
  position: absolute;
  right: ${props => props.theme.spacing(3)}px;
  top: ${props => props.theme.spacing(3)}px;
`;

export default ConfirmModal;
